import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  USER_LIST_SUBSCRIPTION_BY_COACH_BEGIN,
  USER_LIST_SUBSCRIPTION_BY_COACH_SUCCESS,
  USER_LIST_SUBSCRIPTION_BY_COACH_FAILURE,
  USER_LIST_SUBSCRIPTION_BY_COACH_DISMISS_ERROR,
} from './constants';
import config from '../../../common/config';
import { createAxiosConfigWithAuth } from '../../../common/apiHelpers';
import axios from 'axios';

export function listSubscriptionByCoach(args = {}) {
  return (dispatch, getState) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: USER_LIST_SUBSCRIPTION_BY_COACH_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${config.apiRootUrl}/subscriptions/list-subscription-by-coach`,
        createAxiosConfigWithAuth(getState()),
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: USER_LIST_SUBSCRIPTION_BY_COACH_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: USER_LIST_SUBSCRIPTION_BY_COACH_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissListSubscriptionByCoachError() {
  return {
    type: USER_LIST_SUBSCRIPTION_BY_COACH_DISMISS_ERROR,
  };
}

export function useListSubscriptionByCoach() {
  const dispatch = useDispatch();

  const { listSubscriptionByCoachPending, listSubscriptionByCoachError } =
    useSelector(
      (state) => ({
        listSubscriptionByCoachPending:
          state.user.listSubscriptionByCoachPending,
        listSubscriptionByCoachError: state.user.listSubscriptionByCoachError,
      }),
      shallowEqual,
    );

  const boundAction = useCallback(
    (...args) => {
      return dispatch(listSubscriptionByCoach(...args));
    },
    [dispatch],
  );

  const boundDismissError = useCallback(() => {
    return dispatch(dismissListSubscriptionByCoachError());
  }, [dispatch]);

  return {
    listSubscriptionByCoach: boundAction,
    listSubscriptionByCoachPending,
    listSubscriptionByCoachError,
    dismissListSubscriptionByCoachError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case USER_LIST_SUBSCRIPTION_BY_COACH_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        listSubscriptionByCoachPending: true,
        listSubscriptionByCoachError: null,
      };

    case USER_LIST_SUBSCRIPTION_BY_COACH_SUCCESS:
      // The request is success
      return {
        ...state,
        listSubscriptionByCoachPending: false,
        listSubscriptionByCoachError: null,
      };

    case USER_LIST_SUBSCRIPTION_BY_COACH_FAILURE:
      // The request is failed
      return {
        ...state,
        listSubscriptionByCoachPending: false,
        listSubscriptionByCoachError: action.data.error,
      };

    case USER_LIST_SUBSCRIPTION_BY_COACH_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        listSubscriptionByCoachError: null,
      };

    default:
      return state;
  }
}
